import {all} from 'redux-saga/effects';
import {
  fetchModelInstances as fetchModelInstancesAction,
  fetchModelTypes as fetchModelTypesAction
} from './';
import {fetchModelInstances, fetchModelTypes} from 'sdk/quicksearch';
import {createFetchSagaLatest} from 'utils/sagas';

function* quickSearchSaga() {
  yield all([
    createFetchSagaLatest(fetchModelInstancesAction, fetchModelInstances),
    createFetchSagaLatest(fetchModelTypesAction, fetchModelTypes)
  ]);
}

export default quickSearchSaga;
